<template>
  <div class="container">

    <div class="hero-section">
        <h1>Rocket เงินกู้ – ปลดล็อกพลังการเงินอย่างมั่นใจ ด้วยเทคโนโลยีที่ทันสมัย</h1>
        <p>Rocket เงินกู้ คือแพลตฟอร์มสินเชื่อส่วนบุคคลที่ออกแบบมาเพื่อคนไทยยุคใหม่ ที่ต้องการความรวดเร็ว สะดวก และปลอดภัย เรานำเทคโนโลยีการประมวลผลข้อมูลและการเข้ารหัสระดับธนาคารมาช่วยให้การกู้ยืมเป็นเรื่องง่าย โปร่งใส และเชื่อถือได้</p>
        <p>ไม่ว่าคุณต้องการจัดการค่าใช้จ่ายฉุกเฉิน ปรับสภาพคล่อง หรือวางแผนทางการเงิน Rocket เงินกู้ พร้อมช่วยคุณก้าวไปข้างหน้าอย่างมั่นใจ</p>
    </div>

    <div class="section">
        <div class="img-col">
          <div class="app-mockup">
            <img :src="importedImg1" alt="" class="imgItem" />
          </div>
        </div>
        <div class="text-col">
            <h2>จุดเด่นผลิตภัณฑ์</h2>
            <ul>
                <li>
                    <span class="highlight">วงเงินสูงสุด 38,000 บาท</span><br>
                    อนุมัติตามความเหมาะสมของผู้กู้
                </li>
                <li>
                    <span class="highlight">ระยะเวลาผ่อนชำระยืดหยุ่น 120 – 365 วัน</span><br>
                    ปรับตามความสามารถในการชำระของคุณ
                </li>
                <li>
                    <span class="highlight">อัตราดอกเบี้ยต่อปีสูงสุด (APR) ไม่เกิน 13.5% ต่อปี</span><br>
                    คิดดอกเบี้ยอย่างโปร่งใส ไม่มีค่าธรรมเนียมแอบแฝง
                </li>
                <li>
                    <span class="highlight">ระบบอัตโนมัติรวดเร็ว</span><br>
                    ตรวจสอบข้อมูลและทราบผลการประเมินได้ในเวลาไม่นาน
                </li>
                <li>
                    <span class="highlight">ความปลอดภัยระดับสูง</span><br>
                    ใช้การเข้ารหัสข้อมูลตลอดกระบวนการตามมาตรฐาน PDPA
                </li>
            </ul>
        </div>
    </div>

    <div class="section reverse">
      <div class="app-mockup">
        <img :src="importedImg2" alt="" class="imgItem" />
      </div>
        <div class="text-col">
            <h2>ตัวอย่างการคำนวณสินเชื่อ (เพื่อการอ้างอิงเท่านั้น)</h2>
            
            <div class="glass-card">
                <p>หากคุณกู้ <strong>20,000 บาท</strong> ระยะเวลา <strong>6 เดือน (180 วัน)</strong><br>
                อัตราดอกเบี้ยต่อปี (APR) <strong>ไม่เกิน 13.5%</strong></p>
                <hr style="border: 0; border-top: 1px solid rgba(0,0,0,0.1); margin: 20px 0;">
                <ul style="list-style: none; padding: 0;">
                    <li>🔹 <strong>ดอกเบี้ยต่อเดือน</strong> = 20,000 × (13.5% ÷ 12) = <span class="highlight">225 บาท</span></li>
                    <li>🔹 <strong>ค่างวดต่อเดือน</strong> ≈ 20,000 ÷ 6 + 225 = <span class="highlight">3,558 บาท</span></li>
                    <li>🔹 <strong>ดอกเบี้ยรวม 6 เดือน</strong> = 225 × 6 = <span class="highlight">1,350 บาท</span></li>
                </ul>
                <h3 style="margin-top: 20px; color: #088395;">ยอดชำระรวม = 21,350 บาท</h3>
            </div>
            <p style="font-size: 14px; color: #777; margin-top: 10px;">หมายเหตุ: ตัวเลขเป็นเพียงตัวอย่าง อัตราจริงขึ้นอยู่กับผลประเมินเครดิตของผู้กู้</p>
        </div>
    </div>

    <div class="section">
      <div class="img-col">
      <div class="app-mockup">
        <img :src="importedImg3" alt="" class="imgItem" />
      </div>
    </div>
        <div class="text-col">
            <h2>คุณสมบัติผู้สมัคร</h2>
            <ul style="list-style: none; padding: 0; font-size: 20px;">
                <li> <strong>อายุ 20 ปีขึ้นไป</strong></li>
                <li> <strong>มีบัตรประชาชนไทยที่ยังไม่หมดอายุ</strong></li>
                <li> <strong>มีรายได้ประจำหรือมีความสามารถในการชำระ</strong></li>
                <li> <strong>พักอาศัยอยู่ในประเทศไทย</strong></li>
            </ul>
        </div>
    </div>

    <div class="section reverse">
      <div class="app-mockup">
        <img :src="importedImg4" alt="" class="imgItem" />
      </div>
        <div class="text-col">
            <h2>ข้อกำหนดสำคัญตามนโยบาย Google Play</h2>
            <ul style="list-style: none; padding: 0;">
                <li style="display: flex; align-items: flex-start;">
                    <span>ไม่มีการเข้าถึงข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาต</span>
                </li>
                <li style="display: flex; align-items: flex-start;">
                    <span>การอนุมัติขึ้นอยู่กับการประเมินของระบบอย่างอิสระ</span>
                </li>
                <li style="display: flex; align-items: flex-start;">
                    <span>เงื่อนไข และผลการประเมินอาจแตกต่างกันในแต่ละบุคคล</span>
                </li>
                <li style="display: flex; align-items: flex-start;">
                    <span>ผู้ใช้สามารถขอแก้ไขข้อมูล ลบข้อมูล หรือถอนความยินยอมได้ตามสิทธิ PDPA</span>
                </li>
            </ul>
        </div>
    </div>

</div>

</template>

<script>
import "./index.css";
import importedImg1 from "@/page/rocktloan.aurorafinsynergy/components/img/product1.png";
import importedImg2 from "@/page/rocktloan.aurorafinsynergy/components/img/product2.png";
import importedImg3 from "@/page/rocktloan.aurorafinsynergy/components/img/product3.png";
import importedImg4 from "@/page/rocktloan.aurorafinsynergy/components/img/product4.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style scoped>
  body {
      margin: 0;
      padding: 0;
      background-color: #FDFFFE; 
      font-family: 'Prompt', sans-serif;
      color: #333333;
      overflow-x: hidden;
      min-width: 1400px; 
      min-width: 1400px;
      max-width: 100vw; 
  }
  .container {
      width: 90%;
      min-width: 1400px;
      max-width: 1620px;
      margin: 0 auto; 
      padding: 60px 150px;
      box-sizing: border-box;
  }


  h1 { font-size: 48px; color: #088395; margin-bottom: 24px; line-height: 1.3; font-weight: 700; }
  h2 { font-size: 32px; color: #088395; margin-bottom: 20px; font-weight: 600; }
  h3 { font-size: 24px; color: #333; margin-bottom: 10px; font-weight: 600; }
  p, li { font-size: 18px; line-height: 1.8; color: #555; margin-bottom: 16px; }
  
  ul { padding-left: 20px; }
  li { margin-bottom: 12px; }

  .highlight { color: #088395; font-weight: 600; }

  .section {
      display: flex;
      align-items: center; 
      justify-content: space-between;
      margin-bottom: 120px; 
      padding: 40px 0; 
      position: relative; 
  }
  .section.reverse {
      flex-direction: row-reverse;
  }


  .text-col {
      flex: 1;
      padding: 0 60px; 
      z-index: 2; 
  }


  .img-col {
      flex: 0 0 500px; 
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2;
  }


  .app-mockup {
      width: 300px; 
      aspect-ratio: 1242 / 2688; 
      background-color: #eef2f5; 
      border-radius: 40px; 
      box-shadow: 0 20px 40px rgba(0,0,0,0.15); 
      border: 8px solid #fff; 
      overflow: hidden;
      position: relative;
  }

  .app-mockup img {
      width: 100%;
      height: 100%;
      object-fit: cover; 
      display: block;
  }

  .hero-section {
      text-align: center;
      max-width: 1000px;
      margin: 60px auto 100px auto;
      position: relative;
      background-color: #FDFFFE; 
      z-index: 1;
  }

  .glass-card {
      background: rgba(255, 255, 255, 0.4); 
      border-radius: 20px;
      padding: 30px;
      box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px); 
      -webkit-backdrop-filter: blur(10px); 
      border: 1px solid rgba(255, 255, 255, 0.3); 
      max-width: 700px;
  }


  .decorative-shape {
      position: absolute;
      z-index: 1; 
      background-color: rgba(144, 202, 249, 0.4); 
      border-radius: 50%;
      pointer-events: none; 
  }

  /* Hero 区域的装饰 */
  .hero-section::before, .hero-section::after {
      content: '';
      position: absolute;
      background-color: rgba(0, 86, 179, 0.05);
      pointer-events: none;
  }
  .hero-section::before {
      width: 150px; height: 150px; border-radius: 20px; top: 0; left: -100px; transform: rotate(15deg);
  }
  .hero-section::after {
      width: 250px; height: 250px; border-radius: 50%; bottom: -50px; right: -150px;
  }


  .section:nth-child(3)::after {
      content: '';
      position: absolute;
      width: 400px;
      height: 400px;
      background-color: rgba(0, 86, 179, 0.02); /* 浅蓝色 */
      border-radius: 50%;
      right: 45%; 
      top: 20%;
      z-index: 0;
  }
</style>
